export const codeMasterType = {
  agency: "Agency",
  bu: "BU",
  bcpTemplate: "BCPTemplate",
  country: "Country",
  div: "Div",
  divisionGroup: "DivisionGroup",
  educationDegree: "EducationDegree",
  employmentType: "EmploymentType",
  frequency: "Frequency",
  gender: "Gender",
  gscmDiv: "GSCMDiv",
  gscmDivSap: "GSCMDIV_SAP",
  imceType: "ImceTypeChoices",
  imceTypeChoice: "imceTypeChoices",
  language: "Language",
  newModelDisplayStatus: "NewModelDisplayStatus",
  normalSurveyType: "NormalSurveyType",
  questionType: "QuestionType",
  resultCopy: "ResultCopy",
  salesForceRankType: "SalesForceRankType",
  salesForceType: "SalesForceType",
  siteStatus: "siteStatus",
  siteType: "siteType",
  storeType: "storeType",
  status: "Status",
  surveyTypeColor: "SurveyTypeColor",
  taskCategory: "TaskCategory",
  type: "SurveyType",
  user: "User",
  userGrade: "UserGrade",
  userRole: "UserRole",
  userSiteRelation: "UserSiteRelation",
  userStatus: "UserStatus",
  userType: "UserType",
  workingExperience: "WorkingExperience",
  modelUDFType: 'ModelUDFType',
  modelStatus: 'ModelStatus',
  smsVnIntfStatus: 'SMSVnIntfStatus',
  smsVnIntfType: 'SMSVnIntfType',
  weeklyEmailSummaryReportCategory: 'WeeklyEmailSummaryRptCategory',
  smsLogMessageType: 'SMSLogMessageType',
  smsLogDivisionType: 'SMSLogDivisionType',
  smsLogStatus: 'SMSLogStatus',
  batchJobSubsidiary: 'BatchJobSubsidiary',
  batchJobStatus: 'BatchJobStatus',
  batchJobFreq: 'BatchJobFreq',
  smsLogFSMAccept: 'SMSLogFSM_Accept',
  smsLogFSMSNType: 'SMSLogFSM_SNType',
  smsLogFSMToMatch: 'SMSLogFSM_ToMatch',
  hhpDistyCoverageType: 'HHPDistyCoverageType',
  rawDataType: 'RawDataType',
  planogramType: 'PlanogramType',
  planogramDivGroup: 'NewMCS|PlanogramDiv',
  campaignSite: 'PlanogramViewSiteID',
  storeGrade: 'StoreGrade',
  siteInfo: 'SITE_INFO',
  currentBU: 'GetCurrentBU'
}

export const passwordValidationCodes = {
  alphaNumericMix: { code: "EM00000150", message: "The password should have a combination of alphabets and numbers." },
  minLength: { code: "EM00000149", message: "The password should be made up of at least 8 characters." },
  noUserId: { code: "EM00000155", message: "The password cannot contain the same character as User ID." },
  recursiveNumber: { code: "EM00000152", message: "Passwords with characters in running sequence or fixed sequence are not allowed (eg. abcd, abab, 1234)" },
  sameWord: { code: "EM00000153", message: "The alphabet, number or special character cannot be entered in consecutive sequence over 4 times (eg. 2222, bbbb) " },
  specialCharactor: { code: "EM00000151", message: "The password should also contain at least one special character(~,!,@,#,$,%,&,*,-,=,_,+,[,],{,})." },
  specialWord: { code: "EM00000154", message: "The password must not contain the word.[sds,samsung,manager,admin,mcs]." },
}

export const formats = {
  API_MONTH_FORMAT: "YYYYMM", // Moment format for API request
  API_QUARTER_FORMAT: "YYYYQ", // Moment format for API request
  API_WEEK_FORMAT: "GGGGWW", // Moment format for API request
  apiDateFormat: "YYYYMMDD",
  dateFormat: "YYYY.MM.DD",
  ISO_DATE_FORMAT: "YYYY-MM-DD",
  LOCAL_TIME: "YYYY.MM.DD hh:mm:ss A",
  MONTH_FORMAT: "YYYY-MM", // Moment format for display
  QUARTER_FORMAT: "YYYY[Q]Q", // Moment format for API request
  WEEK_FORMAT: "GGGG-[W]WW", // Moment format for display
  YEAR_FORMAT: 'YYYY',
}

export const staticUrls = {
  emptyUserImage: "static/images/user/sample-profile.png",
  fileImage: "static/images/file/file-image.jpg",
  imageUnavailable: "static/images/image_not_available.png",
};

export const vocStatus = {
  CODES: [
    {
      code: "0001",
      name: "Pending <= 1M",
      color: "var(--is-warning-yellow)"
    },
    {
      code: "0002",
      name: "Action Done - Verify",
      color: "var(--is-roadshow-green)",
    },
    {
      code: "0003",
      name: "Close Without Resolution",
      color: "var(--is-primary-blue)",
    },
    {
      code: "0004",
      name: "Close",
      color: "var(--is-primary-blue)"
    },
    {
      code: "9999",
      name: "Pending > 1M",
      color: "var(--is-danger-red)"
    },
  ],
  getColor: function (code) {
    let status = this.CODES.find((s) => s.code === code);
    if (status) {
      return status.color;
    } else {
      return undefined;
    }
  },
  getName: function (code) {
    let status = this.CODES.find((s) => s.code === code);
    if (status) {
      return status.name;
    } else {
      return undefined;
    }
  },
};

export const VOC_STATUS_CODES = [
  {
    code: "0001",
    name: "Pending <= 1M",
    color: "var(--is-warning-yellow)",
  },
  {
    code: "0002",
    name: "Action Done - Verify",
    color: "var(--is-roadshow-green)",
  },
  {
    code: "0003",
    name: "Close Without Resolution",
    color: "var(--is-primary-blue)",
  },
  {
    code: "0004",
    name: "Close",
    color: "var(--is-primary-blue)",
  },
  {
    code: "9999",
    name: "Pending > 1M",
    color: "var(--is-danger-red)",
  },
];

export const MIME_TYPES_AND_FILE_EXTENSION = [
  // Images
  { extension: '.gif', mimeType: 'image/gif' },
  { extension: '.jpeg', mimeType: 'image/jpeg' },
  { extension: '.jpg', mimeType: 'image/jpeg' },
  { extension: '.png', mimeType: 'image/png' },

  // Applications
  { extension: '.ppt', mimeType: 'application/vnd.ms-powerpoint' },
  { extension: '.docx', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
  { extension: '.pptx', mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' },
  { extension: '.xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { extension: '.xls', mimeType: 'application/vnd.ms-excel' },
  { extension: '.doc', mimeType: 'application/msword' },
  { extension: '.pdf', mimeType: 'application/pdf' },
  { extension: '.zip', mimeType: 'application/zip' },

  // Texts
  { extension: '.xml', mimeType: 'text/xml' },
  { extension: '.txt', mimeType: 'text/plain' },
]

export const SURVEY_TYPES = {
  GLOBAL: 'Y',
  NORMAL: 'N',
  QUICK: 'Q',
  PUBLIC: 'P'
};

export const SURVEY_QUESTION_TYPE_CODES = {
  TEXT: "0001",
  SINGLE: "0002",
  MULTIPLE: "0003",
  PHOTO: "0004",
  NUMBER: "0005",
  DATE: "0006",
  GPS: "0007",
  SINGLE_DROPDOWN: "0008",
  MULTI_DROPDOWN: "0009",
  BARCODE: "0010",
  YES_NO: "0011",
  RATING: "0012",
};

export const PURCHASE_ORDER_STATUS_CODE = {
  PENDING: "000",
  APPROVED: "001",
  REJECTED: "002",
};

/** @author cmc.nttruong1 */
export const EDITABLE_FLAG = {
  ALL: "All",
  EDITABLE: "Editable",
  UNEDITABLE: "Uneditable",
};

export const DIRECT_PURCHASE = {
  DIRECT: "DIRECT",
  INDIRECT: "INDIRECT",
};

export const FILE_EXTENSIONS = {
  DOC: '.doc',
  DOCX: '.docx',
  GIF: '.gif',
  JPEG: '.jpeg',
  JPG: '.jpg',
  PDF: '.pdf',
  PNG: '.png',
  PPT: '.ppt',
  PPTX: '.pptx',
  XLS: '.xls',
  XLSX: '.xlsx',
  ZIP: '.zip',
  XML: '.xml',
}

export const SITE_STATUS = [
  {
    "code": "0001",
    "name": "Active",
    "class": "site-active",
  },
  {
    "code": "0002",
    "name": "Closed",
    "class": "site-closed",
  },
  {
    "code": "0003",
    "name": "Low Active",
    "class": "site-low-active",
  },
  {
    "code": "0005",
    "name": "Inactive",
    "class": "site-inactive",
  },
  {
    "code": "0004",
    "name": "Request",
    "class": "site-request",
  }
];

export const REPORT_DATA_TYPE = {
  DATA_GROUP: "DataGroup",
  DATA_SOURCE: "DataSource",
  MOBILE_REPORT_PERIOD: "MobileReportPeriod",
  REPORT_PERIOD: "ReportPeriod",
};

export const DATE_TYPE_CODES = {
  DATE: 'D',
  DAY: 'D',
  WEEK: 'W',
  MONTH: 'M',
  MTD: 'T',
  QUARTER: 'Q',
  YEAR: 'Y',
};

export const REPORT_GRID_LAYOUT = {
  FLAT: 'flat',
  CLASSIC: 'classic',
  COMPACT: 'compact',
  HTML: 'html'
}

export const COUNTRY_CODES = {
  AUSTRALIA: 'AU',
  INDONESIA: 'ID',
  CAMBODIA: 'KH',
  LAOS: 'LA',
  MYANMAR: 'MM',
  MALAYSIA: 'MY',
  NEW_ZEALAND: 'NZ',
  PHILIPPINES: 'PH',
  SINGAPORE: 'SG',
  THAILAND: 'TH',
  VIETNAM: 'VN'
}

export const KEYS_SEPARATOR = '^^';
export const KEY_VALUE_SEPARATOR = ':=';
export const VALUES_SEPARATOR = '^';
export const COMMON_SEARCH_DATA_TYPES = {
  VENDOR: 'POSM_VENDOR',
  RECEIVE_BY: 'RECEIVE_BY',
  REQUESTER: 'REQUESTER',
  RETAIL: 'RETAIL'
}
export const GOODMOVEMENT_MAP_OBJECT = {
  MovementTypeName: "Movement Type",
  MovementControlId: "Movement Code",
  MovementDate: "Date",
  Model: "Model",
  BasicModel: "Basic Model",
  GoodsControlId: "Control No",
  MovementQty: "Qty",
  UnitPrice: "Unit Price",
  Amount: "Value",
  CalcStockQty: "Total Qty",
  CalcMvgPrice: "MVG Price",
  StockValue: "Total Value",
  MovementBy: "Requester",
  FromVendor: "Vendor",
  FromWarehouse: "From Warehouse",
  FromStorage: "From Storage Location",
  ChannelCode: "Retail Code",
  ChannelName: "Retail",
  ToWarehouse: "To Warehouse",
  ToStorage: "To Storage Location",
  RefNo: "Ref No",
  Remarks: "Remarks",
  FileName1: "Proof 1",
  FileName2: "Proof 2",
  FileName3: "Proof 3",
  FileName4: "Proof 4",
  FileName5: "Proof 5",
  FileId1: null,
  FileId2: null,
  FileId3: null,
  FileId4: null,
  FileId5: null,
  RowNum: null,
  MovementId: null,
  MovementType: null,
  GoodsType: null,

}
export const FILE_NAME_MAP = {
  FileName1: "FileId1",
  FileName2: "FileId2",
  FileName3: "FileId3",
  FileName4: "FileId4",
  FileName5: "FileId5",
}
export const LABEL_GOODMOVEMENT_MAP_OBJECT = {
  MovementTypeName: "LT00001284",
  MovementControlId: "LT00001239",
  MovementType: "LT00001254",
  MovementDate: "LT00000132",
  Model: "LT00000717",
  BasicModel: "LT00001268",
  GoodsControlId: "LT00001272",
  MovementQty: "LT00001283",
  UnitPrice: "LT00001282",
  Amount: "LT00001098",
  CalcStockQty: "LT00001273",
  CalcMvgPrice: "LT00001274",
  StockValue: "LT00001240",
  MovementBy: "LT00001241",
  FromVendor: "LT00001088",
  FromWarehouse: "LT00001242",
  FromStorage: "LT00001243",
  ChannelCode: "LT00001244",
  ChannelName: "LT00001245",
  ToWarehouse: "LT00001246",
  ToStorage: "LT00001247",
  RefNo: "LT00001279",
  Remarks: "LT00000152",
  FileName1: "LT00001248",
  FileName2: "LT00001249",
  FileName3: "LT00001250",
  FileName4: "LT00001251",
  FileName5: "LT00001252",
}
export const GOODMASTER_MAP_OBJECT = {
  ReceiveDate :{
    code: "LT00001281", apiProps: "Receive Date"
  },
  GoodsType :{
    code: "LT00001267", apiProps: "Goods Type"
  },
  Division :{
    code: "LT00000241", apiProps: "Division"
  },
  Model :{
    code: "LT00000717", apiProps: "Model"
  },
  BasicModel :{
    code: "LT00001268", apiProps: "Basic Model"
  },
  GoodsControlId :{
    code: "LT00001272", apiProps: "Control No"
  },
  StockQty :{
    code: "LT00001273", apiProps: "Total Qty"
  },
  MvgPrice :{
    code: "LT00001274", apiProps: "Mvg Price"
  },
  StockValue :{
    code: "LT00001098", apiProps: "Value"
  },
  UseDueDate :{
    code: "LT00001276", apiProps: "Use Due Date"
  },
  UseDueDay :{
    code: "LT00001314", apiProps: "Use Aging Day"
  },
  StockDueDate :{
    code: "LT00001275", apiProps: "Stock Due Date"
  },
  StockDueDay :{
    code: "LT00001315", apiProps: "Stock Aging Day"
  },
  D1_15 :{
    code: "", apiProps: "1~15"
  },
  D16_30 :{
    code: "", apiProps: "16~30"
  },
  D31_60 :{
    code: "", apiProps: "31~60"
  },
  D61_90 :{
    code: "", apiProps: "61~90"
  },
  D91_120 :{
    code: "", apiProps: "91~120"
  },
  D121_150 :{
    code: "", apiProps: "121~150"
  },
  D151_MORE :{
    code: "", apiProps: "150~more"
  }
}

export const ROUTE_PLAN_COLORS_SET = [
  [231, 76, 60],
  [230, 126, 34],
  [241, 196, 15],
  [39, 174, 96],
  [22, 160, 133],
  [52, 152, 219],
  [44, 62, 80],
  [155, 89, 182],
  [233, 30, 99],
  [142, 91, 45],
  [163, 203, 56],
  [26, 188, 156]
];

export const WORK_TEMPLATE_STATUS = [
  {
    name: "Active",
    code: "001"
  },
  {
    name: "Inactive",
    code: "002"
  }
];